import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connectStream, compose } from '../../lib/bastetjs/utils/connectStream';
import { injectIntl } from 'react-intl';
import { EventResultsStreams } from '../../data/EventResultsStreams';
import { EventStreams } from '../../data/EventStreams';
import { RaceStreams } from '../../data/RaceStreams';
import { getTokenRacerId } from '../../utils/isLoggedIn';
import { eventBus } from '../../data/Streams';
import { getExtraData } from '../../data/ExtraEventStream';
import { getAthleteRacesStream } from '../../data/AthleteStreams';
import { connect } from 'react-redux';
import { getNotifications } from '../../data/NotificationStreams';
import { ReigniteEventRbiResults } from './ReigniteEventRbiResults'
import { useFirebaseConfig } from '../../lib/firebase/remote-config';
import { EventResultsComponent } from './EventResultsComponent';
import { ReigniteEventLeaderboardResults } from './ReigniteEventLeaderboardResults'

const PureEventResults = (props: any) => {
  const firebaseConfig = useFirebaseConfig()
  const ctliveEventId = props.master?.event?.ctliveId
  if (ctliveEventId && firebaseConfig.useSse?.asBoolean()) {
    const intervalId = props.eventResultsFilters.split
    if (isNaN(intervalId)) {
      return <ReigniteEventLeaderboardResults
        {...props}
      />
    }
    return <ReigniteEventRbiResults
      {...props}
    />
  }
  return <EventResultsComponent
    {...props}
  />
}

const mapStateToProps = (state: any) => ({
  dispatch: undefined,
  eventMetadata: state.eventMetadata,
  eventResults: state.eventResults,
  eventResultsFilters: state.eventResultsFilters
});

export const EventResults = compose(
  connect(mapStateToProps),
  withTranslation(),
  injectIntl,
  connectStream({
    master: EventResultsStreams.getErpEvent,
    races: ({ masterId }: any) => RaceStreams.receiveAthlinksRacesByMasterId({ masterId }),
    currentEvent: ({ eventId }: any) => EventStreams.getEventByEventId(eventId, undefined), // TODO: get this in meta call
    currentEventStatus: ({ eventId, masterId }: any) => EventStreams.getEventStatus('ERP-current-event', { eventId, masterId }),
    search: () => eventBus.getTopic('event_results_search'),
    page: () => EventResultsStreams.getPage(),
    extra: ({ eventId }: any) => getExtraData(eventId),
    athleteRaces: () => getAthleteRacesStream(getTokenRacerId()),
    notifications: getNotifications
  }),
  withRouter,
)(PureEventResults);